export class CustomHtmlContent {
  key: string;
  content: string;
}
